import React from 'react';
import style from './Bookshelf.module.scss';
import BookshelfFrame from './BookshelfFrame/BookshelfFrame';

function Handbook() {
  return (
    <div className='flex h-full min-h-0 flex-col'>
      <BookshelfFrame className={style.filesContainer} />
    </div>
  );
}

export default Handbook;
